import { StaticImage } from "gatsby-plugin-image"
import React from "react"

const Banner = ({ data }) => {
  console.log("Banner: ", data);
  return (
    <div className="banner-wrap full-bleed bg-gray-200 overflow-hidden">
      {data.nodes.length === 0 ? (
        <StaticImage
          className="w-full"
          src="https://dummyimage.com/2200x1198/000/ffffff"
          alt="placeholder"
          placeholder="blurred"
        />
      ) : (
        data.nodes.map(banner => (
          <a
            key={banner?.meta?.url}
            target="_blank"
            href={banner?.meta?.url === null ? "/" : banner?.meta?.url}
          >
            <div className="img-wrap w-full h-full">
              <img
                className="w-full h-full object-cover"
                src={banner.url}
                alt="banner image"
              />
            </div>
          </a>
        ))
      )}
    </div>
  )
}

export default Banner
